import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import Button from '../ui/Button';
import { authService } from '../../services/api/auth';

interface LogoutButtonProps {
  className?: string;
  variant?: 'outline' | 'ghost' | 'primary' | 'secondary' | 'danger';
  /** Icône seule, avec le libellé en info-bulle : pour le pied du menu. */
  iconeSeule?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ 
  className = '', 
  variant = 'ghost',
  iconeSeule = false,
  size = 'md'
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    if (window.confirm('Êtes-vous sûr de vouloir vous déconnecter ?')) {
      setIsLoading(true);
      
      try {
        // Utiliser le service d'authentification pour la déconnexion
        await authService.logout();
        
        console.log('✅ Déconnexion réussie');
        
        // Rediriger vers la page d'accueil
        navigate('/', { replace: true });
      } catch (error) {
        console.error('❌ Erreur lors de la déconnexion:', error);
        // Même en cas d'erreur, rediriger quand même
        navigate('/', { replace: true });
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <Button
      onClick={handleLogout}
      loading={isLoading}
      variant={variant}
      size={size}
      className={`text-gray-600 hover:text-red-600 ${className}`}
    >
      <span title="Se déconnecter" className="inline-flex items-center">
        <LogOut className={`w-4 h-4 ${iconeSeule ? '' : 'mr-2'}`} />
        {!iconeSeule && (isLoading ? 'Déconnexion...' : 'Déconnexion')}
      </span>
    </Button>
  );
};

export default LogoutButton;
